import { render, staticRenderFns } from "./CurationFilterSendLayout.vue?vue&type=template&id=e5e531f4&scoped=true"
import script from "./CurationFilterSendLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterSendLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e531f4",
  null
  
)

export default component.exports